'use strict';

var style = require('./style');

module.exports = style({
  prop: 'borderRadius',
  key: 'radii',
  numberToPx: true
});


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/border-radius.js
// module id = 4323
// module chunks = 168707334958949